import {Component} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "woa-field-pair",
    templateUrl: "./field-pair.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: FieldPairComponent, multi: true}]
})
export class FieldPairComponent {
}



// WEBPACK FOOTER //
// ./src/app/inputs/form/field-pair/field-pair.component.ts